import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const JULY_2025_CAMPAIGN_END_DATE = d(2025, 8, 4, 0, 0);
